$('body').on('click', '#free-liquids-box .fpclick, .cus_free_pro', function() {
      $('#myNav').css('width', '100%');
      $('#myNav').css('display', 'block');
      var data_id = $(this).attr('data-id');
      $('#myNav').attr('data-id', data_id);
    });
    function openNav() {
      document.getElementById("myNav").style.width = "100%";
    }
    function closeNav() {
      document.getElementById("myNav").style.width = "0%";
    }
 $('body').on('click', '.option-add-btn', function() {
  var data_id = $('#myNav').attr('data-id')  
  jQuery(".overlay").hide();
  jQuery( ".select_item" ).html( "Change" );
  jQuery( ".product_added" ).html( "Free E-liquid Added!" );
 var title = $(this).closest('.grid__item').children('.free-product-card').children('.product-card-wrapper').attr('data-title');
 var img = $(this).closest('.grid__item').children('.free-product-card').children('.product-card-wrapper').attr('data-img');
 var selected_variant = $(this).closest('.popup-variant-option').find('.popup-select__select option:selected').val(); 
 var selct_variant_id = $(this).closest('.popup-variant-option').find('.option-add-btn').attr('product_id');
 var selct_variant_title = $(this).closest('.popup-variant-option').find('.option-add-btn').attr('variant_title');
 var get_preorder = $(this).closest('.product-form').siblings(".free-pro-variant").find('.select__select option:selected').attr('data-preorder');
 var get_preorder_text = $(this).closest('.product-form').siblings(".free-pro-variant").find('.select__select option:selected').attr('pre-order_text');   
   var get_free_count = $('.custom-attributes-options').attr('data-free');
    if (data_id == '0'){
      $('#fplistproducts .free_product_1').html('<div class="cus_free_pro" data-id="0" data-pro_id="'+selct_variant_id+'" data-preorder="'+get_preorder+'" data-preorder_text="'+get_preorder_text+'"> <img src="'+img+'"> <div> <h4>'+title+'-'+selct_variant_title+'</h4> <p><i>Click to Change the flavour</i></p> </div> </div>')
      $('.free-liquid-id-0').addClass('free_active');
    }
    else if(data_id == '1'){
      $('#fplistproducts .free_product_2').html('<div class="cus_free_pro" data-id="1" data-pro_id="'+selct_variant_id+'" data-preorder="'+get_preorder+'" data-preorder_text="'+get_preorder_text+'"> <img src="'+img+'"> <div> <h4>'+title+'-'+selct_variant_title+'</h4> <p><i>Click to Change the flavour</i></p> </div> </div>')
      $('.free-liquid-id-1').addClass('free_active');
    }
   else if(data_id == '2'){
      $('#fplistproducts .free_product_3').html('<div class="cus_free_pro" data-id="2" data-pro_id="'+selct_variant_id+'" data-preorder="'+get_preorder+'" data-preorder_text="'+get_preorder_text+'"> <img src="'+img+'"> <div> <h4>'+title+'-'+selct_variant_title+'</h4> <p><i>Click to Change the flavour</i></p> </div> </div>')
      $('.free-liquid-id-2').addClass('free_active');
   }
   else if(data_id == '3'){
      $('#fplistproducts .free_product_4').html('<div class="cus_free_pro" data-id="3" data-pro_id="'+selct_variant_id+'" data-preorder="'+get_preorder+'" data-preorder_text="'+get_preorder_text+'"> <img src="'+img+'"> <div> <h4>'+title+'-'+selct_variant_title+'</h4> <p><i>Click to Change the flavour</i></p> </div> </div>')
      $('.free-liquid-id-3').addClass('free_active');
   }
   else if(data_id == '4'){
      $('#fplistproducts .free_product_5').html('<div class="cus_free_pro" data-id="4" data-pro_id="'+selct_variant_id+'" data-preorder="'+get_preorder+'" data-preorder_text="'+get_preorder_text+'"> <img src="'+img+'"> <div> <h4>'+title+'-'+selct_variant_title+'</h4> <p><i>Click to Change the flavour</i></p> </div> </div>')
      $('.free-liquid-id-4').addClass('free_active');
   }
   var freeActiveCount = $('.free_active').length;
   if (freeActiveCount == get_free_count){
     $('.free-add-to-crt button').prop('disabled', false);
   }
  return false;  
  });
/*********************************Change Variant*******************************************/
$('body').on('change', '.popup-variant-option select', function () {
   var get_id = $(this).children('option:selected').attr('id');
   var get_title = $(this).children('option:selected').val();
   $(this).closest('.popup-variant-option').children('.option-add-btn').attr('product_id', get_id);
   $(this).closest('.popup-variant-option').children('.option-add-btn').attr('variant_title', get_title);
});
/**********************************free Add Button************************************************/

$('body').on('click', '.free-add-to-crt button', function () {
  var ship_value = $('.preorder-property').val();
  var ship_value1 = $('.show_ship_dates').text();
  var qty_value = $(this).closest('.buy-now-qty').find('quantity-input').children('.quantity__input').val();
 // alert(qty_value)
  $(this).children('span').css('display', 'none');
  $(this).children('.loading__spinner').removeClass('hidden');
  if (ship_value != ''){
    var value_1 = ship_value;
     var ship_values = ship_value1;
  }
  var main_product = $('.product-variant-id').val();
  var main_free_pro_1 = $('.free_product_1').children('.cus_free_pro').attr('data-pro_id');
  var main_free_pro_preorder1 = $('.free_product_1').children('.cus_free_pro').attr('data-preorder');
  var main_free_pro_preorder_text1 = $('.free_product_1').children('.cus_free_pro').attr('data-preorder_text');
  var main_free_pro_2 = $('.free_product_2').children('.cus_free_pro').attr('data-pro_id');
  var main_free_pro_preorder2 = $('.free_product_2').children('.cus_free_pro').attr('data-preorder');
  var main_free_pro_preorder_text2 = $('.free_product_1').children('.cus_free_pro').attr('data-preorder_text');
  var main_free_pro_3 = $('.free_product_3').children('.cus_free_pro').attr('data-pro_id');
  var main_free_pro_preorder3 = $('.free_product_3').children('.cus_free_pro').attr('data-preorder');
  var main_free_pro_preorder_text3 = $('.free_product_1').children('.cus_free_pro').attr('data-preorder_text');
  var main_free_pro_4 = $('.free_product_4').children('.cus_free_pro').attr('data-pro_id');
  var main_free_pro_preorder4 = $('.free_product_4').children('.cus_free_pro').attr('data-preorder');
  var main_free_pro_preorder_text4 = $('.free_product_1').children('.cus_free_pro').attr('data-preorder_text');
  var main_free_pro_5 = $('.free_product_5').children('.cus_free_pro').attr('data-pro_id');
  var main_free_pro_preorder5 = $('.free_product_5').children('.cus_free_pro').attr('data-preorder');
  var main_free_pro_preorder_text5 = $('.free_product_1').children('.cus_free_pro').attr('data-preorder_text');
//  console.log(main_product + '-----' + main_free_pro_1 + '---------' + main_free_pro_2 + '-------' + main_free_pro_3);

  var pre_free_pro_text1 = "";
  var pre_free_pro_1 = "";
  var pre_free_pro_text2 = "";
  var pre_free_pro_2 = "";
  var pre_free_pro_text3 = "";
  var pre_free_pro_3 = "";
  var pre_free_pro_text4 = "";
  var pre_free_pro_4 = "";
  var pre_free_pro_text5 = "";
  var pre_free_pro_5 = "";

// Check if each product is preorder by comparing to the string 'true'
if(main_free_pro_preorder1 === 'true') {
    pre_free_pro_text1 = main_free_pro_preorder_text1;
    pre_free_pro_1 = 'Pre-order'
}

if(main_free_pro_preorder2 === 'true') {
    pre_free_pro_text2 = main_free_pro_preorder_text2;
    pre_free_pro_2 = 'Pre-order'
}

if(main_free_pro_preorder3 === 'true') {
    pre_free_pro_text3 = main_free_pro_preorder_text3;
    pre_free_pro_3 = 'Pre-order'
}
  
  if (main_product && main_product !== 'undefined') {
    const itemsToAdd = [];

    if (main_product !== '' && main_product !== 'undefined') {
      itemsToAdd.push({ 
        id: main_product, 
        quantity: qty_value,
        properties: {
          'Note': value_1,
          'Note 1': ship_values
        }
      });
    }
    if (main_free_pro_1 && main_free_pro_1 !== 'undefined') {
      itemsToAdd.push({ 
        id: main_free_pro_1, 
        quantity: 1,
        properties: {
          'Note': pre_free_pro_1,
          'Note 1': pre_free_pro_text1
        }
      });
    }
    if (main_free_pro_2 && main_free_pro_2 !== 'undefined') {
      itemsToAdd.push({ 
        id: main_free_pro_2, 
        quantity: 1,
        properties: {
          'Note': pre_free_pro_2,
          'Note 1': pre_free_pro_text2
        }
      });
    }
    if (main_free_pro_3 && main_free_pro_3 !== 'undefined') {
      itemsToAdd.push({ 
        id: main_free_pro_3, 
        quantity: 1,
        properties: {
          'Note': pre_free_pro_3,
          'Note 1': pre_free_pro_text3
        }
      });
    }
    if (main_free_pro_4 && main_free_pro_4 !== 'undefined') {
      itemsToAdd.push({ 
        id: main_free_pro_4, 
        quantity: 1,
        properties: {
          'Note': pre_free_pro_4,
          'Note 1': pre_free_pro_text4
        }
      });
    }
    if (main_free_pro_5 && main_free_pro_5 !== 'undefined') {
          itemsToAdd.push({ 
            id: main_free_pro_5, 
            quantity: 1,
            properties: {
              'Note': pre_free_pro_5,
              'Note 1': pre_free_pro_text5
            }
          });
       }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: itemsToAdd }),
    })
     
    .then(response => response.json())
       
    .then(data => {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cartData) {
          console.log(data);
          if(data.status == 422){
            $('.product-form__error-message-wrapper-1').remove();
            $('.buy-now-qty').after('<div class="product-form__error-message-wrapper-1" role="alert"><span class="product-form__error-message">'+data.message+'</span></div>');
          }
          else{
            $('.product-form__error-message-wrapper-1').remove();
          }
          let updatedQuantity = cartData.item_count || 0;
          $("#cart-icon-bubble .cart-count-bubble").remove();
          $("#cart-icon-bubble .visually-hidden").after('<div class="cart-count-bubble">'+updatedQuantity+'</div>'); 
         // $('#cart-notification').load(window.location.href + ' #CartDrawer');
          $('#cart-notification').addClass('active');
          $('.header__icon--cart svg .icon-fill').attr('fill', 'currentColor');
          $('#cart-notification #cart-notification-product').empty();
          $('cart-drawer').load(window.location.href + ' #CartDrawer');
          $('cart-drawer').removeClass('is-empty');
          $('cart-drawer').addClass('active');
          $('cart-drawer').addClass('animate');
          $('body').addClass('overflow-hidden');
          //$('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
          var product_data = '';
          /****************notification popup*****************/
          $.each(data.items, function (index, item) {
                 product_data += '<div class="custom-cart-notification">'
                 product_data += '<div class="cart-notification-product__image global-media-settings">';
                 product_data += '<img src="'+item.image+'" width="70" height="70">';
                 product_data += '</div>';
                 product_data += '<div><h3 class="cart-notification-product__name h4">';
                 product_data += item.product_title;
                 product_data += '</h3><dl><div class="product-option">';
                 product_data += '<dt>'+item.options_with_values[0].name+': </dt>';
                 product_data += '<dd>'+item.options_with_values[0].value+'</dd>';
                 product_data += '</div></dl></div></div>';
            });
          
          $('.quick-add-modal__toggle').trigger('click');
          $('#cart-notification-button').text('View my cart ('+cartData.item_count+')');
            $('cart-notification #cart-notification-product').append('<div class="cart-notification-data">'+product_data+'</div>');
        }
      });
    })
      
    .catch(error => console.error('Error adding items to cart:', error));
  } else {
    console.log('Neither product ID is found.');
  }

  setTimeout(function() {
   $('.free-add-to-crt').children('button').children('span').css('display', 'block');
   $('.free-add-to-crt').children('button').children('.loading__spinner').addClass('hidden');
  }, 2000);

  return false;
});


/*******************************Disable add to cart button*******************************/
setTimeout(function() {

var get_variant_preorder = $('select.select__select option:selected').attr('data-preorder');
if (get_variant_preorder == 'true'){
 // alert(get_variant_preorder);
  var get_ship_text = $('.show_ship_dates').text();  
  $('.preorder-property').val('Pre-order');
  $('.show_ship_dates').removeClass('hide'); 
  $('.preorder-property_note').val(get_ship_text);
}else{
 // alert(get_variant_preorder)
  $('.preorder-property').val('');
  $('.show_ship_dates').addClass('hide'); 
  $('.preorder-property_note').val('');
}
  
var ship_data = $('#vitals-preorder-note').text();
   $('#vitals-preorder-notes').val(ship_data);
//alert(ship_data)
 }, 1000);
 $('body').on('click', 'variant-radios label', function() {
//    var get_free_count = $('.custom-attributes-options').attr('data-free');
//    var freeActiveCount = $('.free_active').length;
//    if (freeActiveCount != get_free_count){
//     setTimeout(function() {
//     $('.free-add-to-crt button').addClass('dfdfd');
//     $('.free-add-to-crt button').attr('disabled','disabled');
//   }, 1500); 
//    }
  var ship_data = $('#vitals-preorder-note').text();
   $('#vitals-preorder-notes').val(ship_data);
 })